<template>
<transition name="fade">
  <div class="menu-open" v-if="menuOpen">
    <a href="#" class="menu-open__close size-small" @click.prevent="$store.commit('closeMenu')">Close</a>
    <nav-items @click.prevent="$store.commit('closeMenu')" position="top" class="size-large"></nav-items>
  </div>
</transition>
</template>

<script>
import Vue from 'vue'

export default Vue.component('TopMenu', {
  computed: {
    menuOpen() {
      return this.$store.state.menuOpen
    }
  }
})
</script>

<style lang="scss" scoped>
@import '~@/_variables.scss';

.menu-open {
  position: fixed;
  top: 0; left: 0;
  bottom: 0; right: 0;
  z-index: 8;
  background: transparentize($color-red, 0.03);
  overflow-y: auto;

  &__close {
    position: fixed;
    top: $gutter; left: $gutter;
    padding: 1.1rem 0;
    width: 7rem;
    text-align: center;
    color: $color-white;
    font-family: $font-mono;
    font-weight: normal;
    text-transform: uppercase;
    background: $color-black;
  }

  nav {
    text-transform: uppercase;
    color: $color-black;
    line-height: 1;
    margin-left: 50%;
    padding: $gutter 0;

    @media (max-width: $break-small) {
      margin-left: $gutter;
      margin-top: 6.4rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/top-menu.vue